"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUpdateNotificationList = void 0;
const frontend_infra_localisation_1 = require("@forto-dev/frontend-infra-localisation");
const frontend_infra_reactquery_1 = require("@forto-dev/frontend-infra-reactquery");
const lodash_es_1 = require("lodash-es");
const useNotificationListState_1 = require("../hooks/useNotificationListState");
const getNotifications_1 = require("./getNotifications");
const useUpdateNotificationList = () => {
    const queryClient = (0, frontend_infra_reactquery_1.useQueryClient)();
    const { current } = (0, frontend_infra_localisation_1.useI18n)();
    const { page, pageSize, typeFilter, statusFilter, startDateFilter, endDateFilter, sortBy } = (0, useNotificationListState_1.useNotificationListState)();
    const updateNotificationList = ({ ids, status }) => {
        const queryKey = [
            getNotifications_1.NOTIFICATIONS_KEY,
            page,
            pageSize,
            current,
            (0, lodash_es_1.pickBy)({
                type: typeFilter,
                status: statusFilter,
                startDate: startDateFilter,
                endDate: endDateFilter,
                orderBy: sortBy,
            }, lodash_es_1.identity),
        ];
        const userNotifications = queryClient.getQueryData(queryKey);
        if (userNotifications?.results) {
            const updatedNotificaitons = userNotifications.results.map((userNotification) => {
                return ids.includes(userNotification.id) ? { ...userNotification, status } : userNotification;
            });
            queryClient.setQueryData(queryKey, { ...userNotifications, results: updatedNotificaitons });
        }
    };
    return updateNotificationList;
};
exports.useUpdateNotificationList = useUpdateNotificationList;
//# sourceMappingURL=useUpdateNotificationList.js.map